import { Pipe, PipeTransform } from '@angular/core';
import { UtilitiesService } from '../../services/utilities/utilities.service';

@Pipe({
    name: 'filterGroups',
    standalone: false
})
export class FilterGroupsPipe implements PipeTransform {

  constructor(private utilities: UtilitiesService) {}

  transform(groups: any, searchTerm?: string): any {
    // to filter page template groups based on search text
    if (this.utilities.isValidString(searchTerm)) {
      groups = groups.filter(x => x.name.toLocaleLowerCase().indexOf(searchTerm.toLocaleLowerCase()) > -1);
    }
    return groups;
  }

}
